import { useSubscription } from '@meraki-internal/state';
import { WrapWithCardOnLargerScreen } from '../components/WrapWithCardOnLargerScreen';
import { ResourcesState } from './ResourcesState';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { IonButton, IonText } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { mediaMinWidth, mediaMaxWidth } from '../theme/utils';
import { useSearchParams } from '../utils/useSearchParams';

const useStyles = createUseStyles(() => ({
    outer: {
        [mediaMinWidth.xl]: {
            position: 'fixed',
            top: 25,
            left: '12%',
            width: '15%',
            minWidth: 220,
            maxWidth: 240,
        }
    },
    inner: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 15,
        padding: '5px 5px 20px',

        [mediaMinWidth.xl]: {
            flexDirection: 'column',
            padding: 20
        }
    },
    button: {
        margin: 0,

        [mediaMaxWidth.sm]: {
            // currently we have 4 categories, which always wrap on phones,
            // so add some padding so we get 2 on each row
            '--padding-start': '25px',
            '--padding-end': '25px'
        }
    }
}));

export const ResourceFilters: React.FC = () => {
    const classes = useStyles();

    const searchParams = useSearchParams();
    const selectedCategory = searchParams.get('category');

    const resourcesState = useInstance(ResourcesState);
    useSubscription(() => resourcesState);

    const categories = resourcesState.getCategories();

    if (!categories.length) {
        return null;
    }

    const isSelected = (category: string) => {
        return category.toLowerCase() === selectedCategory;
    };

    const toggle = (category: string) => {
        if (isSelected(category)) {
            resourcesState.filterTo({ category: undefined, trackingFrom: 'Filters' });
        } else {
            resourcesState.filterTo({ category, trackingFrom: 'Filters' });
        }
    };

    return (
        <div className={classes.outer} data-type="resource-filters">
            <WrapWithCardOnLargerScreen breakpoint="xl">
                <div className={classes.inner}>
                    {categories.map(category => (

                        <IonButton
                            key={category}
                            fill={isSelected(category) ? 'solid' : 'outline'}
                            color={isSelected(category) ? 'primary' : 'medium'}
                            className={classes.button}
                            onClick={() => toggle(category)}
                        >
                            <IonText style={{color: isSelected(category) ? undefined : 'var(--ion-color-step-750)'}}>
                                {category}
                            </IonText>
                        </IonButton>

                    ))}
                </div>
            </WrapWithCardOnLargerScreen>
        </div>
    );
};
